import script from "./MainTopNavComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainTopNavComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MainTopNavComponent.vue?vue&type=style&index=0&id=f59af9c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f59af9c2"]])

export default __exports__